import { useState, useEffect } from "react";
import { Tabs, Form, Select, message, Modal } from "antd";
import PropTypes from "prop-types";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import UpdateConnectionPopup from '../../Popup/UpdateConnectionPopup';
import { AddUser } from '../../style';
import { setEditCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { BasicFormWrapper } from '../../../styled';
import { updateCase } from '../../../../Api/Services/CaseApiServices'

const { Option } = Select;

const LeadTabPage = ({ displayData, getDetailsData }) => {
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const [inlineStatus, setInlineStatus] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [edit] = useState(true)
    const handleEditFieldChange = () => {
        setInlineStatus(!inlineStatus)
        dispatch(setEditCall(!inlineStatus));
        getDetailsData()
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const onSubmit = async (values) => {
        let hideMessage;
        const { status } = values;
        const payload = {
            caseStatus: status,
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await updateCase(payload, displayData?.caseId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                    hideMessage();
                }
                else {
                    hideMessage();
                    const isAutomation = response.data[0].message === AutomationMessage;
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    } else {
                        message.success(
                            <span>
                                Case <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                            </span>
                        );
                    }
                    dispatch(setEditCall(false));
                    setInlineStatus(false)
                    getDetailsData()
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (displayData) {
            form.setFieldsValue({
                status: displayData.caseStatus,
            })
        }
    }, [displayData])
    const getRefreshtheTable = () => {
        dispatch(setEditCall(false));
        setInlineStatus(false)
        getDetailsData()
    }
    return (
        <>
            <AddUser>
                <div className="user-info-form">
                    <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed}>
                        <BasicFormWrapper>
                            <div className="add-product-block">
                                <div className="add-product-content">
                                    <Tabs defaultActiveKey="1">
                                        <TabPane tab="Case Info" key="1">
                                            <Form.Item label="Case Subject" name="subject" className="custom-form-item">
                                                <span className="">{displayData?.caseSubject}</span>
                                            </Form.Item>
                                            <Form.Item label="Case Number" name="number" className="custom-form-item">
                                                <span className="">{displayData?.caseNumber}</span>
                                            </Form.Item>
                                            <Form.Item label="Case Type" name="type" className="custom-form-item">
                                                <span className="">{displayData?.caseType}</span>
                                            </Form.Item>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <div style={{ flex: 1 }}>
                                                    <Form.Item label="Case Status" name="status" className="custom-form-item" rules={inlineStatus ? [{ required: true, message: 'Please select case status' }] : [{ required: false }]}>
                                                        {inlineStatus ? <Select style={{ width: '100%', textAlign: "left" }} placeholder="Select Case status" onChange={(value) => form.setFieldsValue({ status: value || null })}>
                                                            <Option value="New">New</Option>
                                                            <Option value="Closed">Closed</Option>
                                                            <Option value="On Hold">On Hold</Option>
                                                            <Option value="Escalated">Escalated</Option>
                                                        </Select> :
                                                            <div
                                                                className={edit ? "edit-span text_icon" : ""}
                                                                // style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: edit ? "pointer" : "default", width: '100%' }}
                                                            >
                                                                <span>{displayData?.caseStatus}</span>
                                                                {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange()} />
                                                                }
                                                            </div>
                                                        }
                                                    </Form.Item>
                                                </div>
                                                {inlineStatus ?
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                        <div
                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                            role="button"
                                                            tabIndex={0}
                                                            title="Cancel"
                                                            onClick={() => {
                                                                handleEditFieldChange(); getDetailsData()
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                    handleEditFieldChange(); getDetailsData()
                                                                }
                                                            }}
                                                            aria-label="cancel"
                                                        >
                                                            <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                        </div>
                                                        <div
                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                            role="button"
                                                            tabIndex={0}
                                                            title="Save"
                                                            onClick={() => form.submit()}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                    form.submit();
                                                                }
                                                            }}
                                                            aria-label="save"
                                                        >
                                                            <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                        </div>
                                                    </div> : <></>}
                                            </div>
                                            <Form.Item label="Case Origin" name="origin" className="custom-form-item">
                                                <span className="">{displayData?.caseOrigin}</span>
                                            </Form.Item>
                                            <Form.Item label="Case Priority" name="priority" className="custom-form-item">
                                                <span className="">{displayData?.casePriority}</span>
                                            </Form.Item>
                                            <Form.Item label="Requested Resolution Date" name="date" className="custom-form-item">
                                                <span className="">{displayData?.requestedResolutionDate && profile?.dateFormate ? moment(displayData?.requestedResolutionDate).format(profile?.dateFormate) : (displayData?.requestedResolutionDate && moment(displayData?.requestedResolutionDate).format("YYYY-MM-DD"))}</span>
                                            </Form.Item>
                                        </TabPane>
                                        <TabPane tab="Case Details" key="2">
                                            <Form.Item label="Description" name="description" className="custom-form-item" >
                                                <span>{displayData?.description}</span>
                                            </Form.Item>
                                            <Form.Item label="Solution" name="solution" className="custom-form-item" >
                                                <span>{displayData?.solution}</span>
                                            </Form.Item>
                                            <Form.Item label="Comment" name="comment" className="custom-form-item" >
                                                <span>{displayData?.comment}</span>
                                            </Form.Item>
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </BasicFormWrapper>
                    </Form >
                </div>
            </AddUser >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Case" getCallBack={getRefreshtheTable} />}

        </>
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
    getDetailsData: PropTypes.func.isRequired,
}
export default LeadTabPage;
